<div class="">
  <div class="grid-40-60">
    <div class="pad-30 border-right border-c desk-view pos-r" style="padding: 50px 40px">
      <div class="flex">
        <div class="icon-40 mar-r-20">
          <img loading="lazy" src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
        </div>
        <div class="flex flex-d-c" style="line-height: 1.3;">
          <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
          <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
        </div>
      </div>

      <div class="flex align-c justify-c pad-t-50 pad-b-20">
        <img loading="lazy"
          src="https://app.atmavaan.com/uploads/{{postObj.customer_type?description[postObj.customer_type]?.img:'Login_SCreen_svg_454_2024-05-16_06:26:48.svg'}}"
          style="height: 340px;width: 320px;">
      </div>

      <div class="sub-c font-12 mar-t-10" style="width: 329px;">
        <div *ngIf="!postObj.customer_type"> With our platform, you can quickly access rates from multiple liners,
          effortlessly book shipments, and track
          them in real-time.</div>
        <div class="f-w-500 head-c font-14 mar-b-15 pos-r" *ngIf="!!postObj.customer_type">
          {{description[postObj.customer_type]?.name}}
          <div class="pos-a ctype-line"></div>
        </div>
        <div *ngIf="!!postObj.customer_type" [innerHTML]="description[postObj.customer_type]?.description"></div>
      </div>
    </div>
    <div>
      <div class="pad-d-50 {{getOTP!=true ? 'over-h-ngotp' : 'over-h'}}">

        <div class="d-f">
          <div class="icon-40 mar-r-20">
            <img loading="lazy" src="https://app.atmavaan.com/uploads/{{AppInfo?.logo}}" class="width-100">
          </div>
          <div class="flex flex-d-c" style="line-height: 1.3;">
            <div class="text-c font-18 f-w-500">{{AppInfo?.portal_name}}</div>
            <div class="font-10 f-w-500">{{AppInfo?.tag_line}}</div>
          </div>
        </div>
        <div class="mar-b-20">
          <div class="font-18 f-w-500 pad-b-5">Create an {{AppInfo?.portal_name | titlecase}} Account</div>
          <div class="sub-c font-12">We're here to enhance your logistics experience!</div>
        </div>

        <div *ngIf="getOTP==false">
          <ng-container [ngTemplateOutlet]="customerTypetemplate" *ngIf="!!postObj.customer_type"></ng-container>

          <div class="mar-b-20 grid grid-40-40 grid-gap-20">
            <div>
              <div class="input-bc text-field flex mar-b-5  {{postObj.first_name != '' ? 'bg-none':''}}">
                <input type="text" placeholder=" " [(ngModel)]="postObj.first_name"
                  class="text-base pad-10 {{postObj.first_name == '' ? 'border-n':''}}">
                <span class="font-s fname-ph width-fl overflow-e"></span>
              </div>
              <span *ngIf="validateError['first_name'] == true" class="font-12 warn-c">Please enter First Name</span>
            </div>

            <div>
              <div class="input-bc text-field flex mar-b-5 {{ postObj.last_name != '' ? 'bg-none':''}}">
                <input type="text" placeholder=" " [(ngModel)]="postObj.last_name"
                  class="text-base pad-10 {{postObj.last_name == '' ? 'border-n':''}}">
                <span class="font-s lname-ph width-fl overflow-e"></span>
              </div>
              <span *ngIf="validateError['last_name'] == true" class="font-12 warn-c">Please enter Last Name</span>
            </div>
          </div>


          <div class="mar-b-20">
            <div class="input-bc text-field flex mar-b-5 {{postObj.email != '' ? 'bg-none':''}}">
              <input type="email" placeholder=" " [(ngModel)]="postObj.email"
                class="text-base pad-10 {{postObj.email == '' ? 'border-n':''}}" (change)="checkUserExist()">
              <span class="font-s email-ph wid-90 overflow-e"></span>
            </div>
            <span *ngIf="validateError['email'] == true && postObj.email===''" class="font-12 warn-c">Please enter
              Email</span>
            <span *ngIf="validateError['email'] == true && postObj.email!==''" class="font-12 warn-c">Please enter a
              valid
              email address.</span>
            <span *ngIf="!!userAlreadyExist" class="font-12 warn-c">User Already Exist</span>
          </div>

          <div class="mar-b-20">
            <div class="input-bc text-field flex mar-b-5 {{postObj.company_name != '' ? 'bg-none':''}}">
              <input type="text" placeholder=" " [(ngModel)]="postObj.company_name"
                class="text-base pad-10 {{postObj.company_name == '' ? 'border-n':''}}">
              <span class="font-s cname-ph wid-90 overflow-e"></span>
            </div>
            <span *ngIf="validateError['company_name'] == true" class="font-12 warn-c">Please enter Company Name</span>
          </div>

          <!-- <div class="mar-b-20">
            <div class="input-bc text-field flex mar-b-5 {{postObj.company_profile != '' ? 'bg-none':''}}">
              <input matInput placeholder=" " [(ngModel)]="postObj.company_profile" [matAutocomplete]="auto"
                class="pad-10 text-base {{postObj.company_profile === '' ? 'border-n':''}}"
                (input)="filteredOptions = filterOptionsAndCountryCodes($any($event.target).value, companyProfile, ['dname'])">
              <span class="font-s com-ph wid-90 overflow-e"></span>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let company_profile of filteredOptions" [value]="company_profile.dname">
                  {{ company_profile.dname }}
                </mat-option>
              </mat-autocomplete>
            </div>
            <span *ngIf="validateError['company_profile'] == true" class="font-12 warn-c">Please enter Company
              profile</span>
          </div> -->


          <div class="mar-b-20">
            <div
              class="input-bc text-field-mob flex align-c mar-b-5 text-base {{postObj.phone_number == '' ? 'border-n':''}} {{postObj.phone_number != '' ? 'bg-none':''}}">
              <div class="border-mb pad-l-16 pad-r-10 mar-r-10" style="width: 100px;">
                <div class="flex align-c">
                  <img loading="lazy" *ngIf="!!flag && countryCode!=''" [src]="'https://app.atmavaan.com/uploads/'+flag"
                    class="mar-r-10 flag-img-wh">
                  <input matInput [(ngModel)]="countryCode" [matAutocomplete]="autocode" placeholder="Select"
                    (input)="filteredCountryCodes = filterOptionsAndCountryCodes($any($event.target).value, getCounCode, ['calling_code','country_code','country_name'])"
                    style="background-color: transparent;width: 45px;">
                  <mat-icon>arrow_drop_down</mat-icon>
                </div>
                <mat-autocomplete #autocode="matAutocomplete">
                  <mat-option *ngFor="let code of filteredCountryCodes" [value]="code.calling_code"
                    (click)="flag = code.flag_image">
                    <div class="flex align-c">
                      <img loading="lazy" src="https://app.atmavaan.com/uploads/{{code.flag_image}}"
                        class="flag-img-wh">
                      <div class="mar-l-10">{{code.calling_code}}</div>
                    </div>
                  </mat-option>
                </mat-autocomplete>
              </div>

              <input type="number" placeholder=" " class="pad-10  height-100 border-r-6 pad-l-place"
                [(ngModel)]="postObj.phone_number" (input)="onPhoneNumberInput($event,'mobileNo')">
              <span class="font-s mob-ph wid-90-mob"></span>
            </div>
            <!-- <span *ngIf="validateError['phone_number']== true" class="font-12 warn-c">Please enter Phone number
            </span> -->

            <!-- <span *ngIf="(validateError['phone_number']== false || (countryCode == null && flag == null)) || 
              validateError['phone_number']== false && (countryCode == null || flag == null)" class="font-12 warn-c">
              {{countryCode == null || flag == null ? 'Please enter Country code' : '' }}</span> -->
          </div>


          <div class="mar-b-20">
            <div class="input-bc flex text-field  mar-b-5  {{postObj.password != '' ? 'bg-none':''}}">
              <div class="password-input-container width-100">
                <input placeholder='' [(ngModel)]="postObj.password" (input)="passwordValid()" (click)="ischeck = true"
                  class="pad-10 text-base height-100 {{postObj.password == '' ? 'border-n':''}}"
                  type="{{passwordOpen?'text':'password'}}">
                <span class="font-s pass-ph wid-90 overflow-e"></span>
                <div (click)="passwordOpen=!passwordOpen" class="visibility-icon-container pointer">
                  <div class="material-symbols-outlined icon-20">{{passwordOpen?'visibility':'visibility_off'}}</div>
                </div>
              </div>

            </div>
            <!-- <span *ngIf="validateError['password'] == true" class="font-12 warn-c">Please enter Password</span> -->
          </div>

          <div *ngIf="!!ischeck" class="align-c mar-b-30 flex">
            <div>
              <div class="flex align-c pad-5  ">
                <div class="flex align-c justify-c mar-r-10 {{(!passwordMatchError.len) ?'success-c':'warn-c'}}"
                  style="width: 25px;height: 25px;">
                  <mat-icon class="icon-16 pad-r-10">{{!passwordMatchError.len ? 'done':'clear'}}</mat-icon>
                </div>
                <div class="sub-cc font-12">Has at least 8 Characters</div>
              </div>
              <div class="flex align-c pad-5 ">
                <div class="flex align-c justify-c mar-r-10 {{(!passwordMatchError.letter) ?'success-c':'warn-c'}}"
                  style="width: 25px;height: 25px;">
                  <mat-icon class="icon-16 pad-r-10">{{!passwordMatchError.letter ? 'done':'clear'}} </mat-icon>
                </div>
                <div class="sub-cc font-12">Has an upper case</div>
              </div>
            </div>
            <div>
              <div class="flex align-c pad-5 ">
                <div
                  class="flex align-c justify-c mar-r-10 {{(!passwordMatchError.number_symbol) ?'success-c':'warn-c'}}"
                  style="width: 25px;height: 25px;">
                  <mat-icon class="icon-16 pad-r-10">{{!passwordMatchError.number_symbol ? 'done':'clear'}} </mat-icon>
                </div>
                <div class="sub-cc font-12">Has one number</div>
              </div>
              <div class="flex align-c pad-5 ">
                <div class="flex align-c justify-c mar-r-10 {{(!passwordMatchError.specialChar) ?'success-c':'warn-c'}}"
                  style="width: 25px;height: 25px;">
                  <mat-icon class="icon-16 pad-r-10">{{!passwordMatchError.specialChar ? 'done':'clear'}} </mat-icon>
                </div>
                <div class="sub-cc font-12">Has a special character</div>
              </div>
            </div>
          </div>

          <div class="flex align-c justify-space-between mar-b-30">
            <div class="sub-c font-s width-330">By completing the sign-up process, you agree to our privacy policy</div>
            <button mat-button class="white btn-bg width-100px" (click)="getOtp()">Sign Up</button>
          </div>
        </div>

        <div *ngIf="getOTP==true">
          <div>
            <div class="mar-b-25">
              <div class="sub-c flex otp-al">An OTP has been created and sent to &nbsp;
                <span class="color-b f-w-500">{{postObj.email}}</span>
              </div>
            </div>
            <!-- <div class="sub-c mar-b-25">An OTP has been created and sent to <span class="color-b f-w-500">+91 9876 5XX XXX</span></div> -->
            <div class="mar-b-30">
              <div class="input-bc text-field flex">
                <input type="text" placeholder=" " class="text-base pad-10 {{otpValue == '' ? 'border-n':''}}"
                  [(ngModel)]="otpValue" (input)="onPhoneNumberInput($event,'otp')">
                <span class="font-s otp-ph wid-90 overflow-e"></span>
              </div>
              <div class="error-span mar-t-10 " *ngIf="otpAuthenticationRes === false">Incorrect OTP,
                please enter the valid OTP</div>
            </div>
            <div class="flex align-c justify-space-between mar-b-20">
              <button mat-button class="text-c pointer" (click)="reSendOtp()">Resend OTP</button>
              <!-- <button mat-button class="btn-bg white width-100px1" (click)="signUp()">Sign up</button> -->
              <button mat-button class="{{!!spinner ? 'width-130 col-d text-c' : 'width-100px white btn-bg '}}"
                (click)="OtpAuth()">
                <div class="flex align-c">
                  <div *ngIf="!!spinner" class="mar-r-10">
                    <mat-spinner [diameter]="20" strokeWidth="2"></mat-spinner>
                  </div>
                  <div>{{!!spinner ? 'Verifying' : 'Sign up'}}</div>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div>
          <div>Existing User? <span class="text-c pointer mar-l-10" (click)="login()">Log in here</span></div>
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #customerTypetemplate>
  <div class="grid grid-gap-20 mar-b-20" style="grid-template-columns: calc(50% - 10px) calc(50% - 10px);">
    <div class=" grid grid-gap-5 tab pointer {{postObj?.customer_type=='cargo owner'?'tab-act':'border-c'}}" matRipple
      (click)="postObj.customer_type='cargo owner'" style="grid-template-columns: 30px calc(100% - 35px);">
      <div class="flex align-c justify-c">
        <span class="material-symbols-outlined icon-20">
          {{postObj?.customer_type=='cargo owner'?'radio_button_checked':'radio_button_unchecked'}}</span>
      </div>
      <div>
        <div class="font-12 f-w-500">Cargo Owner</div>
        <div class="font-10 overflow-e">Book your own shipment</div>
      </div>
    </div>
    <div class="grid grid-gap-5 tab pointer {{postObj?.customer_type=='partner'?'tab-act':'border-c'}}" matRipple
      (click)="postObj.customer_type='partner'" style="grid-template-columns: 30px calc(100% - 35px);">
      <div class="flex align-c justify-c">
        <span
          class="material-symbols-outlined icon-20">{{postObj?.customer_type=='partner'?'radio_button_checked':'radio_button_unchecked'}}</span>
      </div>
      <div>
        <div class="font-12 f-w-500">Channel Partner</div>
        <div class="font-10 overflow-e">Buy from and sell to {{AppInfo?.portal_name}}</div>
      </div>
    </div>
  </div>
</ng-template>
